module.exports = __webpack_public_path__ + "static/illustration-011aaf9b33f67775e18bdaf86dba5056.mp4";